import Loader from "components/Loader/Loader";
import DateSelector from "Dashboard/components/DateSelector";
import { useAppDispatch } from "hooks/hooks";
import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  getCreditsStatistics,
  selectState,
} from "../slices/CreditsStatistics.slice";
import { selectState as mainSelectState } from "../slices/main.slice";
import { FormatNumber } from "utils/numberUtils";
import { FormatDate } from "utils/dateUtils";

export const CreditsStatistics = () => {
  const { statistics, loading } = useSelector(selectState);
  const { mainDateFrom } = useSelector(mainSelectState);
  const [dateFrom, setDateFrom] = useState<Date | null>(null);
  const [, setDateTo] = useState<Date | null>(null);
  const [projectsArray, setProjectsArray] = useState<number[]>([]);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (dateFrom != null) {
      dispatch(getCreditsStatistics({ year: dateFrom.getFullYear(), projectIds:projectsArray }));
    }
    console.log(statistics);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateFrom, projectsArray]);

  const selectDate = useCallback((data: { dateFrom: Date; dateTo: Date }) => {
    setDateFrom(data.dateFrom);
    setDateTo(data.dateTo);
  }, []);

  const pushToArray = (index: number) => {
    let newProjectsArray: number[];
    if (projectsArray.includes(index)) {
      newProjectsArray = projectsArray.filter((element) => element !== index);
    } else {
      newProjectsArray = [...projectsArray, index];
    }
    setProjectsArray(newProjectsArray);
  };

  const getWidth = (num: number | undefined) => {
    let totalwidth = 0;
    statistics?.bankEntries.forEach((element) => {
      if (element.loanAmount + element.paidInstallmentsAmount > totalwidth) {
        totalwidth = element.loanAmount + element.paidInstallmentsAmount;
      }
    });
    if (num) {
      let width = totalwidth / num;
      const result = Math.abs(100 / width);
      return Math.round(result);
    } else {
      return 0;
    }
  };

  return (
    <div className="mainDiv">
      <div className="header">Krediti</div>
      <div className="credits-div loading-container">
        {loading && <Loader />}
        <div className="graphs-header carnets-header">
          <span>
            <div className="color13"></div>Iznos kredita
          </span>
          <span>
            <div className="color14"></div>Isplacene rate
          </span>
        </div>
        <div className="credits">
          <span>
            ukupno uzeli <label>{statistics?.totalLoanTaken && FormatNumber(statistics?.totalLoanTaken)} rsd</label>
          </span>
          <br></br>
          <span>
            ostalo da vratimo{" "}
            <label>{statistics?.remainingInstallments && FormatNumber(statistics?.remainingInstallments)} rsd</label>
          </span>
        </div>
        <div className="graphs-content">
          {statistics?.bankEntries &&
            statistics?.bankEntries.map((s) => (
              <span>
                <p className="name">{s.bankName}</p>
                <div className={`color13 singleCreditGraph-${getWidth(s.loanAmount)}`}>
                  <p>{FormatNumber(s.loanAmount)} rsd</p>
                </div>
                <div className={`color14 singleCreditGraph-${getWidth(s.paidInstallmentsAmount)}`}>
                <p>{FormatNumber(s.paidInstallmentsAmount)} rsd</p>
                </div>
              </span>
            ))}
        </div>
      </div>
      <table className="statistics-table-header">
        <colgroup>
          <col className="w5" />
          <col className="w24" />
          <col className="w11" />
          <col className="w10" />
          <col className="w10" />
          <col className="w10" />
          <col className="w11" />
          <col className="w11" />
        </colgroup>
        <thead>
          <tr>
            <th className="selector">
              <DateSelector
                selectedYear={mainDateFrom?.getFullYear()}
                showMonth={false}
                lastYearNumbers={5}
                selectDate={selectDate}
              />
            </th>
            <th className="header-cell">naziv projekta</th>
            <th className="header-cell">kategorija</th>
            <th>datum ugovora</th>
            <th>početak radova</th>
            <th className="header-cell">krajnji rok</th>
            <th className="header-cell">završio</th>
            <th>zaradio</th>
          </tr>
        </thead>
      </table>
      <table className="statistics-table-content loading-container">
        <colgroup>
          <col className="w5" />
          <col className="w24" />
          <col className="w11" />
          <col className="w10" />
          <col className="w10" />
          <col className="w10" />
          <col className="w11" />
          <col className="w11" />
        </colgroup>
        <tbody>
          {statistics?.projectEntries &&
            statistics.projectEntries.map((project, index) => (
              <tr key={index}>
                <td className="firstBtn">
                  <div>
                    <input
                      onChange={() => pushToArray(project.projectId)}
                      type="checkbox"
                      checked={projectsArray.includes(project.projectId)}
                    />
                  </div>
                </td>
                <td>
                  <p>{project.projectName}</p>
                </td>
                <td>{project.category}</td>
                <td>{FormatDate(project.contractDate)}</td>
                <td>{FormatDate(project.startDate)}</td>
                <td>{FormatDate(project.finishDate)}</td>
                <td>{FormatDate(project.dueDate)}</td>
                <td>{FormatNumber(project.paidInstallmentsAmountSoFar)} rsd</td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};
